/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import {
  AccountsMenuLinks,
  moveZapsLink,
} from '@zapier/universal-nav/dist/constants';

import type { UniversalNavLinkType } from '@zapier/universal-nav/dist/constants';
/* eslint-disable import/no-duplicates */
import useAccountsMenuData from './utils/useAccountsMenuData';
import type { Account } from './utils/useAccountsMenuData';
import AccountsMenu from './AccountsMenu';
import type { Props as AccountsMenuProps } from './AccountsMenu';

type Props = Omit<
  AccountsMenuProps,
  'accounts' | 'email' | 'menuLabel' | 'menuLinks'
>;

/**
 * Renders `AccountsMenu` with accounts data
 */
const AccountsMenuContainer = (props: Props) => {
  const result = useAccountsMenuData();
  const { data } = result;

  // The display name for an account is account owner's name
  const accounts = (data?.accounts || []).map((account: Account) => ({
    id: account.id,
    name: account.normalizedName,
    imageUrl: account.normalizedImageUrl,
  }));

  const menuLinks: Array<UniversalNavLinkType> = [...AccountsMenuLinks];
  // This is an annoying workaround because TS doesn't like adding
  // `moveZapsLink` in a ternary and then calling `.filter(Boolean)`
  // to filter it out if it doesn't exist. There's a way around it
  // but it's syntactically confusing.
  if (accounts.length > 1) {
    menuLinks.unshift(moveZapsLink);
  }

  const email = data?.currentUserV2?.email || '';

  return (
    <AccountsMenu
      accounts={accounts}
      email={email}
      menuLinks={menuLinks}
      {...props}
    />
  );
};

export default AccountsMenuContainer;
